import Box from "../../../components/box";
import Btn from "../../../components/btn";
import MultipleBtns from "../../../components/multiplebtns";
import h from "../../../core/createElement";
import { get_object_from_storage, patch_object_on_storage, set_object_on_storage, switchable_element } from "../../../utils";
import InputsContainer from "./inputs_container";
import JsonContainer from "./json_container";

export default function RequestBodyBox({ id, data, shared: ext_shared, name = "req_body_box", onChange, hide }) {
    let req_body = {}, default_body_model = {};

    const
        shared = {},
        multiples_btns = [
            { label: "Inputs" },
            { label: "Raw" }
        ],
        header_btns = [
            <MultipleBtns btns={multiples_btns} onChange={i => switch_containers(i)} />,
            <Btn icon="assets/image/x_white.svg" color="red" onClick={() => hide()} />
        ],
        inputs_container = (
            <InputsContainer
                id={id}
                shared={shared}
                name="inputs_container"
                onChangeObject={o => body_change(o)}
                parameters={data.parameters}
                language={data.language}
            />
        ),
        raw_json_container = (
            <JsonContainer
                shared={shared}
                name="json_container"
                onChangeObject={o => body_change(o)}
            />
        ),
        switcher = switchable_element(inputs_container);

    const
        inputs_patch_values = (v) => shared.inputs_container.patch_values(v),
        json_patch_values = (v) => shared.json_container.patch_values(v);

    const
        switch_containers = (idx) => {
            switch (idx) {
                case 0:
                    inputs_patch_values(req_body);
                    switcher.switch(inputs_container);
                    break;
                case 1:
                    json_patch_values(req_body);
                    switcher.switch(raw_json_container);
                    break;
            };
        },
        body_change = (body) => {
            onChange(req_body = body);
            save_request_body_on_storage(id, req_body);
        };


    const stored_body = get_test_body_from_storage(id);

    default_body_model = shared.inputs_container.get_initial_object();

    if (stored_body) {
        req_body = stored_body;
        inputs_patch_values(req_body);
        json_patch_values(req_body);
    } else {
        req_body = { ...default_body_model };
    };

    ext_shared[name] = {
        get_default_model: () => default_body_model,
        get_current_body: () => req_body,
        clean_stored_body: () => {
            delete_one_stored(id);
            req_body = { ...default_body_model };
            inputs_patch_values(req_body);
            json_patch_values(req_body);
        }
    };

    return (
        <Box title="Corpo da requisição" containerClass="min-w-450" buttons={header_btns}>
            {switcher.current()}
        </Box>
    );
};


function save_request_body_on_storage(id, object) {
    const obj = { ...object };

    if (object.database) obj.database = btoa(JSON.stringify(object.database));

    patch_object_on_storage("report_tests", { ["r_" + id]: obj })
};

function get_test_body_from_storage(id) {
    const o = get_object_from_storage("report_tests");

    const test_body = o["r_" + id] ?? null;

    if (!test_body) return null;

    if (test_body.database) test_body.database = JSON.parse(atob(test_body.database));

    return test_body;
};

function delete_one_stored(id) {
    patch_object_on_storage("report_tests", { ["r_" + id]: null });
};

